module.exports = __webpack_public_path__ + "img/21.02168038.svg";